<template>
  <div class="u-flex u-align-center">
    <blob-panel class="text-center">
      <template v-if="errorMessage || errorType">
        <h3>{{ errorMessage || 'An error occurred' }}</h3>
        <template v-if="errorType === 'invalid-slug'">
          <p class="text-left">
            You have perhaps mistyped or misspelled the Single-Sign On login url. Please check if the url you entered is correct.
          </p>
          <a href="/" class="btn u-mt-xx-large">Back home</a>
        </template>
        <template v-if="errorType === 'no-provider'">
          <p class="text-left">
            The authentication provider has not been correctly configured. Please check whether all the settings are correct and whether the authentication provider has been enabled.
          </p>
          <a href="/" class="btn u-mt-xx-large">Back home</a>
        </template>
      </template>
      <template v-else>
        <img :src="providerLogoUrl" class="header__logo">
        <h2 class="text-center">
          {{ accountName }}
        </h2>

        <h5 class="text-center u-mt-xx-large text-red">
          {{ error }}
        </h5>
        <h5 class="text-center u-mt-xx-large">
          Sign in with your {{ authProviderName }} account to continue
        </h5>

        <div class="text-center u-mt-xx-large">
          <a :href="'/login/' + slug + '/redirect'" class="btn btn--muted">
            <img
              alt="Okta logo"
              :src="`/img/auth-providers/${authProvider}@2x.png`"
              class="u-mr-x-small"
              style="width: 18px;"
            >
            Sign in with {{ authProviderName }}
          </a>
        </div>
      </template>
    </blob-panel>

    <a v-if="defaultLogin" href="/login" class="u-mt-xx-large">
      Login with email and password instead
    </a>
  </div>
</template>

<script>
export default {
  props: [
    'errorType',
    'errorMessage',
    'authProvider',
    'defaultLogin',
    'accountName',
    'providerLogoUrl',
    'slug',
  ],

  computed: {
    authProviderName() {
      return this.ucFirst(this.authProvider)
    },
  },

  methods: {
    login() {
      window.location.reload()
    },
  },
}
</script>
